import { Outlet } from "react-router-dom";
import RoleBasedRoute from "./RoleBasedRoute";
import AuthProvider from "../components/user/AuthProvider";
import DesktopProvider from "../components/DesktopProvider";
import GlobalAppShell from "../components/layouts/GlobalAppShell";

export default function AuthGuard({ fetchBalances = false, fetchProjects = false }) {
  return (
    <AuthProvider fetchBalances={fetchBalances} fetchProjects={fetchProjects}>
      <DesktopProvider>
        <RoleBasedRoute>
          <GlobalAppShell>
            <Outlet />
          </GlobalAppShell>
        </RoleBasedRoute>
      </DesktopProvider>
    </AuthProvider>
  );
}
